import React from "react";
import {BsArrowRepeat} from "react-icons/bs";
import "./LoaderButton.css";
import {Button} from "@mui/material";

export default function LoaderButton({
                                         isLoading,
                                         className = "",
                                         disabled = false,
                                         ...props
                                     }) {
    return (
        <Button
            disabled={disabled || isLoading}
            className={`LoaderButton ${className}`}
            color={"primary"}
            {...props}
        >
            {isLoading && <BsArrowRepeat className="spinning"/>}
            {props.children}
        </Button>
    );
}